import { mString } from 'lib/helpers/utility';

import AddServiceActions from '../components/AddServicesModal/components/AddServiceActions';

export const addServicesModalColumns = [
  {
    headerName: '',
    field: '',
    maxWidth: 40,
    headerCheckboxSelection: true,
    checkboxSelection: (params) => !params.node.group
  },
  {
    field: 'name',
    headerName: 'Name',
    sortable: false,
    flex: 1,
    valueGetter: (params) => params.data?.name || params.data?.cpt_description || ''
  },
  {
    field: 'also_known_as',
    headerName: 'Also known as:',
    sortable: false,
    flex: 1,
    valueGetter: (params) => params.data?.also_known_as || '-'
  },
  {
    field: 'self_pay',
    headerName: 'Self pay',
    cellRenderer: ({ value }) => mString(value || 0),
    sortable: false,
    maxWidth: 120
  },
  {
    field: 'actions',
    headerName: 'Actions',
    sortable: false,
    maxWidth: 100,
    cellRenderer: AddServiceActions,
    pinned: 'right'
  }
];
